import { useEffect, useMemo, useState } from 'react';
import { CopyButton, DetailItem, OutlineButton } from '@recargas-dominicanas/core/components';
import { AccessTokenApi } from '@recargas-dominicanas/core/api';
import type { IAccessToken, IBusinessUser } from '@recargas-dominicanas/core/types';
import { Modal } from '../../../../components/modal/modal.component';
import { style } from './business-user-details-modal.module.css';

interface Props {
  open: boolean;
  title: string;
  businessUser: IBusinessUser;
  onClose: () => void;
}

export function BusinessUserDetailsModal(props: Props) {

  const { open, title, businessUser, onClose } = props;

  const [accessToken, setAccessToken] = useState<IAccessToken | null | undefined>(
    businessUser.user.accessToken
  );
  const isExpired = useMemo(
    () => accessToken != null && Date.now() > Date.parse(accessToken.expirationDate),
    [accessToken]
  );
  const activationLink = accessToken
    ? `${process.env.APP_WEB_APP_DOMAIN}/create-password/${accessToken.token}`
    : '';

  useEffect(() => {
    setAccessToken(businessUser.user.accessToken);
  }, [businessUser]);

  async function handleUpdateLink() {

    if (!accessToken) return;

    setAccessToken(await AccessTokenApi.update(accessToken.id));
  }

  function getState() {
    if (businessUser.state === 'ACTIVATED') return 'Activo';
    if (businessUser.state === 'DISABLED') return 'Inactivo';
    return 'No activado';
  }

  return (
    <Modal
      open={open}
      style={style.modal}
      title={title}
      onClose={onClose}
      secondaryButton='Aceptar'
      onSecondaryClick={onClose}>
      <DetailItem
        style={style.detailItem}
        title='Nombre'
        weight='medium'
        text={businessUser.name}/>
      <DetailItem
        style={style.detailItem}
        title='Usuario'
        weight='medium'
        text={businessUser.userName}/>
      <DetailItem
        style={style.detailItem}
        title='Estado'
        weight='medium'
        color={businessUser.state === 'ACTIVATED' ? 'green' : undefined}
        text={getState()}/>
      {accessToken &&
        <div className={style.activationSection}>
          <div className={style.activationHeader}>
            <span className={style.activationTitle}>Enlace de activación</span>
            <span className={isExpired ? style.expired : style.active}>
              {isExpired ? 'Expirado' : 'Activo'}
            </span>
          </div>
          <div className={style.activationLink}>
            <span className={style.link}>{activationLink}</span>
            <CopyButton className={style.copyButton} text={activationLink}/>
          </div>
          {isExpired &&
            <OutlineButton
              style={style.updateLinkButton}
              text='Actualizar enlace'
              onClick={handleUpdateLink}/>
          }
        </div>
      }
    </Modal>
  );
}
